<template>
  <div class="product-template __base" :id="`wrapper-product_sku__${product.sku}`">
    <product-detail :title="title" :product="product" v-if="product"></product-detail>
  </div>
</template>

<script>
import ProductDetail from '@/components/ProductDetail'

export default {
  name: 'ProductBaseTemplate',
  components: { ProductDetail },
  props: {
    product: { type: Object, required: true },
    title: { type: String, default: 'บริจาค' }
  }
}
</script>



// WEBPACK FOOTER //
// base.vue?2e59b28d